import { Box, Tooltip, Typography } from "@mui/material"
import { REGIME_SCHEDULE_TOTAL_EXPLANATION } from "./regime-schedule-counts-constants.mjs"
import { useListedRegimeScheduleTotal } from "./use-listed-regime-schedule-total"

// Number first, version underneath, so the column stays narrow and the regime names keep their room.
// No tabIndex: the whole row is already the focus stop, and a nested one would trap keyboard users.
export function TableRegimeScheduleTotal() {
    const total = useListedRegimeScheduleTotal()
    if (!total) return null
    return (
        <Tooltip describeChild title={REGIME_SCHEDULE_TOTAL_EXPLANATION}>
            <Box data-cy="regime-schedule-total" sx={{ display: "inline-block" }}>
                <Typography variant="body2" noWrap data-cy="regime-schedule-total-count">
                    {total.count.toLocaleString("en-GB")}
                </Typography>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    component="div"
                    noWrap
                    data-cy="regime-schedule-total-version"
                >
                    {total.label}
                </Typography>
            </Box>
        </Tooltip>
    )
}
